import { ScoopDialog } from '../../../../components/ui'
import styles from './PreviewEmail.module.scss'

function EmailPreviewModal({ rawEmail, open, onClose }) {
    return (
        <ScoopDialog
            open={open}
            onClose={onClose}
            maxWidth="900px"
            title="Email Preview"
        >
            <div
                className={styles.emailContent}
                dangerouslySetInnerHTML={{ __html: rawEmail }}
            />
        </ScoopDialog>
    )
}

export default EmailPreviewModal
